import { PriceListFormState } from "./state";
import { PriceListFormActionType, PriceListFormAction } from './actions';

const initialState = require('./initial-data.json') as PriceListFormState;
export function PriceListFormReducer(state: PriceListFormState = initialState, action: PriceListFormAction): PriceListFormState {
    switch (action.type) {
           case PriceListFormActionType.LoadPriceTypeListAction:
            return {
                ...state,
                priceTypes: action.payload,
            };
            case PriceListFormActionType.LoadVariantCombinationListAction:
                return {
                    ...state,
                   variantCombination: action.payload,
                };     
            
            default:
                return state;
        }
}
